/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef } from 'react';
import * as THREE from "three";

import { const_var, params } from '../../../../../redux/reducers/reducer';
import { controls } from '../../../../../redux/reducers/common/eventReducer';

import { extrudeSettings, ladderTrussBottomRailModel, railModel } from '../../../../../utils/Functions';
import BaseRailModel from '../../BaseRail';
import PillarRailModel from '../../Legs';
import CommonTruss from '../CommonTruss';
import { MaterialTruss } from '../../../CustomMaterial';
import { trussDimensions } from '../../../../../helpers/building_component/truss/truss.helper';

const LCT = ({ trussType, normalMap, envMap, trussModelPosInfoArr, overlapTrussArr, hiddenBaseRailIdArr, meshDelModel_CSG, isFor  }) => {
    let roofRailDistanceY = 0.7;
    let hangRailDivision = 1 / 3;
    const trussDimension = trussDimensions(isFor)

    if(trussType == "RBT"){
        if(trussDimension.buildingWidth <= 40){
            roofRailDistanceY = 0.8;
            hangRailDivision = 1 / 6;
        }else if(trussDimension.buildingWidth > 40 && trussDimension.buildingWidth <= 50 ){
            roofRailDistanceY = 0.8;
            hangRailDivision = 1 / (2.5 + ((trussDimension.buildingWidth-40)*0.06));
        }else{
            roofRailDistanceY = 0.8;
            hangRailDivision = 1 / (2.3 + ((trussDimension.buildingWidth-50)*0.055));
        }
    }
    return (
        <>
            {isFor == 'center' && <BaseRailModel normalMap={normalMap} envMap={envMap} meshDelModel_CSG={meshDelModel_CSG} />}
            {isFor == 'center' && <PillarRailModel trussType={trussType} trussModelPosInfoArr={trussModelPosInfoArr} normalMap={normalMap} envMap={envMap} meshDelModel_CSG={meshDelModel_CSG} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr} roofRailDistanceY={roofRailDistanceY} hangRailDivision={hangRailDivision} />}
            <TrussModel trussType={trussType} trussModelPosInfoArr={trussModelPosInfoArr} normalMap={normalMap} envMap={envMap} meshDelModel_CSG={meshDelModel_CSG} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr} isFor={isFor} />
        </>
    )
}

export default LCT

const TrussModel = ({ trussType, trussModelPosInfoArr, normalMap, envMap, overlapTrussArr, hiddenBaseRailIdArr, isFor }) => {
    const obj_centerVRail = new THREE.Object3D();
    const obj_centerHRail = new THREE.Object3D();
    const obj_connectVShortRail = new THREE.Object3D();
    const obj_underTruss = new THREE.Object3D();
    const vector = new THREE.Vector3(1, 0, 0)

    const ref_centerVRail = useRef();
    const ref_centerHRail = useRef();
    const ref_connectVShortRail = useRef();
    const ref_underTruss = useRef();

    const bottomBaseRailHeight = 0.1;
    const connectRailWidth = 0.3;
    const connectRailHeight = 0.2;
    const offset = 0.035;
    const trussDimension = trussDimensions(isFor)

    const roofRailDistanceY = 0.7;
    const hangRailDivision = 1 / 3;
    const alignPosOffset = useMemo(() => {
        if(params.p_r_s === 1 ) return const_var.roofRegularDst * 2;
        else if(params.p_r_s === 2 || params.p_r_s === 3) return 0;
        else return 0;
    }, [params.p_r_s, trussDimension.roofPitch])

    const roofAlpha = Math.atan(trussDimension.roofPitch / 12);
    const roofHeight = (trussDimension.buildingWidth / 2) * (trussDimension.roofPitch / 12);
    const roofOuterRailLength = useMemo(() => (Math.sqrt(Math.pow(trussDimension.buildingWidth / 2, 2) + Math.pow(roofHeight, 2))), [trussDimension.buildingWidth, roofHeight]);
    let bottomBaseRailLength = (trussDimension.buildingWidth / 2 - connectRailHeight / 2 - connectRailWidth / 2 - trussDimension.roofPitch / 12) * hangRailDivision;
    const roofCenterRailHeight = ((trussDimension.buildingWidth / 2) * trussDimension.roofPitch / 12) * hangRailDivision + roofRailDistanceY;

    if(trussType === "RBT"){
        if(trussDimension.buildingWidth <= 40){
            bottomBaseRailLength = 3
        }else if(trussDimension.buildingWidth > 40 && trussDimension.buildingWidth <= 50 ){
            bottomBaseRailLength = 8
        }else{
            bottomBaseRailLength = 11
        }
    }
    const connectRailDataArr = useMemo(() => {
        let dataInfoArray = [];
        let count, distance;

        let initDistance = (trussType === "RBT") ? (trussDimension.buildingWidth <= 40 && trussDimension.buildingWidth >= 30) ? 2 : (trussDimension.buildingWidth <= 24) ? 4 : 1 : 1.3;
        const tempCount = Math.floor((trussDimension.buildingWidth / 2) / initDistance);
        if ((trussDimension.buildingWidth / 2) === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if ((trussDimension.buildingWidth / 2) - tempCount * initDistance <= initDistance / 2) {
            count = tempCount;
            distance = (trussDimension.buildingWidth / 2) / count;
        } else {
            count = tempCount + 1;
            distance = (trussDimension.buildingWidth / 2) / count;
        }

        for (let i = 1; i <= count; i++) {
            const pos_x = distance * i - connectRailWidth / 2;
            const pos_y = trussDimension.buildingHeight + (trussDimension.buildingWidth / 2 - pos_x) * (trussDimension.roofPitch / 12) - roofRailDistanceY;
            const verticalRailLength = roofRailDistanceY;
            
            const tempInfoObj = {
                distance: distance,
                pos_x: pos_x,
                pos_y: pos_y,
                length: (params.p_r_s === 1 && i === count) ? 0 : verticalRailLength,
            }

            dataInfoArray.push(tempInfoObj);
        }

        return dataInfoArray
    }, [trussDimension.buildingHeight, trussDimension.buildingWidth, trussDimension.roofPitch, trussType])  

    useEffect(() => {
        if (ref_centerHRail.current && ref_centerVRail.current && ref_connectVShortRail.current && ref_underTruss.current) {
            let index_all_1 = 0;
            new Array(2).fill('').forEach((_, index_dir) => {
                let offsetForDir = 1;
                if (index_dir === 1) offsetForDir = 1;
                else offsetForDir = -1;

                new Array(trussModelPosInfoArr.length).fill('').forEach((_, index_truss) => {
                    //----- roof under rail-----
                    obj_underTruss.position.set(offsetForDir * (-trussDimension.buildingWidth / 2 + connectRailWidth / 4), trussDimension.buildingHeight - connectRailHeight / 2 - roofRailDistanceY + alignPosOffset, trussModelPosInfoArr[index_truss]);
                    obj_underTruss.rotation.y = offsetForDir * Math.PI / 2;
                    obj_underTruss.rotateOnAxis(vector, offsetForDir * roofAlpha);
                    //--------------------------

                    //----- bottom base rail-----
                    let height = trussDimension.buildingHeight + roofHeight - roofCenterRailHeight - connectRailHeight + alignPosOffset

                    if(trussType === "RBT"){
                        if(trussDimension.buildingWidth <= 40){
                            height = trussDimension.buildingHeight + roofHeight - (3 * (trussDimension.roofPitch / 12)) - roofRailDistanceY - bottomBaseRailHeight
                        }else if(trussDimension.buildingWidth > 40 && trussDimension.buildingWidth <= 50 ){
                            height = trussDimension.buildingHeight + roofHeight - (8 * (trussDimension.roofPitch / 12)) - roofRailDistanceY - bottomBaseRailHeight
                        }else{
                            height = trussDimension.buildingHeight + roofHeight - (11 * (trussDimension.roofPitch / 12)) - roofRailDistanceY - bottomBaseRailHeight
                        }
                    }

                    obj_centerHRail.position.set(0, height, trussModelPosInfoArr[index_truss] - connectRailWidth / 2);
                    obj_centerHRail.rotation.z = Math.PI / 2;
                    //---------------------

                    //----- roof center rail-----
                    let posY = (trussType === "RBT") ? roofRailDistanceY : roofCenterRailHeight
                    obj_centerVRail.position.set(0, trussDimension.buildingHeight + roofHeight - posY - connectRailHeight + alignPosOffset, trussModelPosInfoArr[index_truss]);
                    obj_centerVRail.rotation.x = -Math.PI / 2;

                    if (trussType !== "LST" && trussType !== "RNT") obj_centerVRail.scale.setScalar(1);
                    else obj_centerVRail.scale.setScalar(0);
                    //---------------------

                    if (hiddenBaseRailIdArr.includes(index_truss)) {
                        obj_underTruss.scale.setScalar(0);
                        obj_centerHRail.scale.setScalar(0);
                        obj_centerVRail.scale.setScalar(0);
                    } else {
                        obj_underTruss.scale.setScalar(1);
                        obj_centerHRail.scale.setScalar(1);
                        obj_centerVRail.scale.setScalar(1);
                    }
                    if(trussType === "RBT" && trussDimension.buildingWidth <= 24) obj_centerHRail.scale.setScalar(0);

                    obj_underTruss.updateMatrix();
                    ref_underTruss.current.setMatrixAt(index_all_1, obj_underTruss.matrix);
                    obj_centerVRail.updateMatrix();
                    ref_centerVRail.current.setMatrixAt(index_all_1, obj_centerVRail.matrix);
                    obj_centerHRail.updateMatrix();
                    ref_centerHRail.current.setMatrixAt(index_all_1, obj_centerHRail.matrix);

                    index_all_1 ++;
                })
            })

            let index_all_2 = 0;
            new Array(2).fill('').forEach((_, index_dir) => {
                let offsetForDir = 1;
                if (index_dir === 0) offsetForDir = 1;
                else offsetForDir = -1;

                new Array(trussModelPosInfoArr.length).fill('').forEach((_, index_truss) => {
                    new Array(connectRailDataArr.length).fill('').forEach((_, index_rail) => {
                        obj_connectVShortRail.position.set(offsetForDir * connectRailDataArr[index_rail].pos_x, connectRailDataArr[index_rail].pos_y - connectRailHeight + alignPosOffset, trussModelPosInfoArr[index_truss]);
                        obj_connectVShortRail.rotation.x = -Math.PI / 2;

                        if ((hiddenBaseRailIdArr.includes(index_truss))) {
                            obj_connectVShortRail.scale.setScalar(0);
                        } else {
                            obj_connectVShortRail.scale.setScalar(1);
                        }

                        if (connectRailDataArr[index_rail].length === 0) obj_connectVShortRail.scale.setScalar(0);
                        
                        obj_connectVShortRail.updateMatrix();
                        ref_connectVShortRail.current.setMatrixAt(index_all_2, obj_connectVShortRail.matrix);

                        index_all_2 ++;
                    })
                })
            })
            
            ref_centerHRail.current.instanceMatrix.needsUpdate = true;
            ref_centerVRail.current.instanceMatrix.needsUpdate = true;
            ref_connectVShortRail.current.instanceMatrix.needsUpdate = true;
            ref_underTruss.current.instanceMatrix.needsUpdate = true;
        }
    }, [ref_centerHRail.current, ref_centerVRail.current, ref_connectVShortRail.current, ref_underTruss.current, trussDimension.buildingWidth, trussDimension.buildingHeight, trussModelPosInfoArr, overlapTrussArr, hiddenBaseRailIdArr, connectRailDataArr, roofHeight, roofCenterRailHeight, alignPosOffset, roofAlpha, trussType, params.activeWall, controls.isCheckActiveTab, trussType])

    return (
        <group position={[0, -offset, 0]} rotation={[0,trussDimension.trussRotation,0]} name='LCT-truss-legs'>
            <CommonTruss trussType={trussType} trussModelPosInfoArr={trussModelPosInfoArr} overlapTrussArr={overlapTrussArr} normalMap={normalMap} envMap={envMap} roofRailDistanceY={roofRailDistanceY} isFor={isFor}/>
            <>
                {/* --- roof unnder truss model --- */}
                <instancedMesh ref={ref_underTruss} args={[null, null, trussModelPosInfoArr.length * 2]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(connectRailWidth, connectRailHeight), extrudeSettings(roofOuterRailLength - 0.04)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
                {/* ------------------------- */}

                {/* --- bottom base rail model --- */}
                <instancedMesh ref={ref_centerHRail} args={[null, null, trussModelPosInfoArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[ladderTrussBottomRailModel(bottomBaseRailLength), extrudeSettings(connectRailWidth)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
                {/* ------------------------- */}

                {/* --- roof center rail model --- */}
                <instancedMesh ref={ref_centerVRail} args={[null, null, trussModelPosInfoArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(connectRailHeight, connectRailWidth), extrudeSettings((trussType === "RBT") ? roofRailDistanceY : roofCenterRailHeight - (trussType === "RNT" && 0.7))]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
                {/* ------------------------- */}

                {/* --- connect rail model --- */}
                <instancedMesh ref={ref_connectVShortRail} args={[null, null, trussModelPosInfoArr.length * connectRailDataArr.length * 2]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(connectRailHeight, connectRailWidth), extrudeSettings(roofRailDistanceY)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
                {/* ------------------------- */}
            </>
        </group>
    )
}
